import { palette } from '../../../styles/variables'
import { MIXPANEL_PROPS } from '../../mixpanel'

export const appBanner = {
  background: palette.darkGray,
  color: palette.white,
  boldColor: palette.orange,
  textBanner: 'bf_offer_ends_soon',
  verticalText: 'exclusive',
  flagText: 'black_friday',
  flagBackground: palette.orange,
  flagClipPath: 'polygon(0% 0%, 100% 0%, 96% 50%, 100% 100%, 0% 100%, 4% 50%)',
  counter: {
    card: {
      background: [
        'linear-gradient(145deg, rgb(77,77,77) 30%, rgb(50,50,50) 70%)',
        'linear-gradient(145deg, rgb(60,60,60) 20%, rgb(38,38,38) 100%)',
      ],
    },
    divider: {
      color: palette.orange,
    },
  },
  purchaseButtonLocation:
    MIXPANEL_PROPS?.PURCHASE_BUTTON_LOCATION?.values?.BF_UBS_BANNER,
}
